import { DocumentViewListPage } from "./_DocumentViewListPage";
import { fetchDocumentsOutgoing } from "@/features/document/api";

export function DocumentOutgoingPage() {
  return (
    <DocumentViewListPage
      title="Văn bản đi"
      breadcrumb="Quản lý Văn bản › Văn bản đi"
      queryKey="documents-outgoing"
      fetcher={fetchDocumentsOutgoing}
    />
  );
}
